import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScannerService {

  public suspended = false;

  public readonly scannedVal$ = new Subject<string>();
}
